import { PermissionAccess } from 'providence-types';

export const canBeEditable = (
  fieldPermission: PermissionAccess,
  isEditing?: boolean,
): boolean => !!isEditing && !!fieldPermission;
